module.exports = __webpack_public_path__ + "src/assets/textures/env/hay/woodboard_hay_1k_bake.png";